import ReglasCoincidencia from './reglas-coincidencia.vue';
import Error403 from './../403.vue';
import RoutesUtils from '../../js/RoutesUtils.js';
import { conUsuarioActualizado } from '../../js/barreraUsuarioActualizado.js';

// El acceso real lo garantiza el backend (403 a quien no sea ADMIN/DIRECTOR, decisión I3 de
// la #47) y la entrada de menú bajo Ajustes, que es el control de acceso de las rutas: el
// listado de roles de aquí solo actúa como respaldo cuando todavía no hay menú cargado.
//
// [#65, 02/10/2026] Entra por la barrera de usuario actualizado, como el resto de pantallas de
// RRHH que deciden algo con los permisos: el respaldo por roles se resuelve con el usuario de
// esta carga y no con el que quedó guardado en el navegador. Aquí importa porque esta pantalla
// ofrece «IA · Pedir nuevas propuestas», que es de ADMIN y DIRECTOR.
const routes = [
    {
        path: '/reglascoincidencia/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: conUsuarioActualizado(function(routeTo) {
            if (!RoutesUtils.tieneAcceso(routeTo.path, ['ADMIN', 'DIRECTOR'])) {
                return { component: Error403 };
            }
            return { component: ReglasCoincidencia };
        }),
        keepAlive: true
    }
];
export default routes;
